import React, { useState, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { inject } from 'mobx-react'
import { EDITOR_GROUPS_STORE } from 'store'
import GroupView from '../GroupView'
import SideComponentContainer from '../SideComponentContainer'
import { GroupSideComponentProps } from './types'

const GroupSideComponent = (props: GroupSideComponentProps) => {
  const {
    [EDITOR_GROUPS_STORE]: {
      selectedGroups,
      getGroupByName,
      relatedProjectsPerGroup,
      updateSelectedGroupRelatedProjects
    },
    group = selectedGroups.length ? getGroupByName(selectedGroups[0]) : null,
    prevSelectedProjects = relatedProjectsPerGroup(group ? group.name : ''),
    projectId
  } = props

  const [showPopup, setShowPopup] = useState(false)
  const [selectedProjectsList, setSelectedProjectsList] = useState([])

  useEffect(() => {
    setSelectedProjectsList([...prevSelectedProjects])
  }, [prevSelectedProjects])

  const handleClick = () => {
    // getProjects();
    setShowPopup(true)
  }

  const handleSubmit = () => {
    const projectsToRemove = []
    prevSelectedProjects.forEach(({ id }) => {
      const index = selectedProjectsList.findIndex(({ id: projectId }) => projectId === id)
      if (index < 0) projectsToRemove.push({ id })
    })

    const projectsToAdd = []
    selectedProjectsList.forEach(({ id }) => {
      const index = prevSelectedProjects.findIndex(({ id: projectId }) => projectId === id)
      if (index < 0) projectsToAdd.push({ id })
    })

    updateSelectedGroupRelatedProjects(projectsToRemove, projectsToAdd)

    setShowPopup(false)
  }

  const onClose = () => {
    setSelectedProjectsList(prevSelectedProjects)
    setShowPopup(false)
  }

  return (
    <SideComponentContainer
      showPopup={showPopup}
      onPopupClose={onClose}
      onPopupSubmit={handleSubmit}
      selectedProjectsList={selectedProjectsList}
      setSelectedProjectsList={setSelectedProjectsList}
      handleActionClick={handleClick}
      relatedProjects={prevSelectedProjects}
      projectId={projectId}
    >
      {group &&
        <GroupView
          {...group}
          isSelectable={false}
        />
      }
    </SideComponentContainer>
  )
}

export default inject(EDITOR_GROUPS_STORE)(observer(GroupSideComponent))
